import axiosInstance from 'api/axiosInstance';
import { CaseDeleteResult } from 'api/cases/types';

/**
 * Guarded case delete. POST /api3.2/cases/:id/delete (Node backend).
 * The server re-derives state; confirmedAttachments must be true when the
 * check reported WARN_ATTACHMENTS. The deleter identity is server-resolved -
 * never sent from here (design DL-12).
 * @param caseId - The case ID
 * @param confirmedAttachments - User acknowledged the attachment warning
 * @returns The delete result (backend plan §2 contract)
 * @throws AxiosError - 409 body carries { error: { code, message } }
 */
const deleteCaseGuarded = async (
  caseId: number,
  confirmedAttachments: boolean,
): Promise<CaseDeleteResult> => {
  try {
    const { data } = await axiosInstance.post(`/api3.2/cases/${caseId}/delete`, {
      confirmedAttachments,
    });
    return data.data as CaseDeleteResult;
  } catch (error) {
    console.error('[deleteCaseGuarded] Failed:', error);
    throw error;
  }
};

export default deleteCaseGuarded;
